import { LegacyPublicationSectionRegion } from "models/interfaces/legacy-publication-section";
import { Record as ImmutableRecord } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const regionDefaultValues: LegacyPublicationSectionRegion =
    RecordUtils.auditableDefaultValuesFactory<LegacyPublicationSectionRegion>({
        pageNumber: undefined,
        polygon: undefined,
    });

export class LegacyPublicationSectionRegionRecord
    extends ImmutableRecord(regionDefaultValues)
    implements LegacyPublicationSectionRegion
{
    constructor(params?: LegacyPublicationSectionRegion) {
        if (params == null) {
            params = Object.assign({}, regionDefaultValues);
        }

        super(params);
    }
}
